import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceProviderRoutingModule } from './service-provider-routing.module';
import { ServiceProviderComponent } from './components/service-provider/service-provider.component';
import { ListServiceProviderComponent } from './components/list-service-provider/list-service-provider.component';
import { AgGridModule } from 'ag-grid-angular';
import { DirectivesModule } from '../../directives/directives.module';
import { FormServiceProviderComponent } from './components/form-service-provider/form-service-provider.component';
import { Trip2ThemeModule } from '../../trip2-theme/trip2-theme.module';
import { T2AutoCompleteLocationModule } from '../A2-utils/t2-autocomplete-location/t2-autocomplete-location.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceProviderService } from '../../core/services/service-provider.service';
import { GridComponentsModule } from '../A2-utils/grid-components/grid-components.module';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { ModalServiceProviderComponent } from './components/modal-service-provider/modal-service-provider.component';
import { AutocompleteServiceProviderComponent } from './components/autocomplete-service-provider/autocomplete-service-provider.component';
import { PaginatorModule } from '../A2-utils/paginator/paginator.module';
import { TextMaskModule } from 'angular2-text-mask';
import { PhoneNumberModule } from 'app/utils/phone-number/phone-number.module';
import { HistoryServiceProviderComponent } from './components/history-service-provider/history-service-provider.component';
import { TabsServiceProviderComponent } from './components/tabs-service-provider/tabs-service-provider.component';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { MergeServiceProviderComponent } from './components/merge-service-provider/merge-service-provider.component';

@NgModule({
  imports: [
    CommonModule,
    ServiceProviderRoutingModule,
    AgGridModule.withComponents([BooleanCheckComponent]),
    DirectivesModule,
    Trip2ThemeModule,
    T2AutoCompleteLocationModule,
    FormsModule,
    ReactiveFormsModule,
    GridComponentsModule,
    TextMaskModule,
    PaginatorModule,
    PhoneNumberModule
  ],
  declarations: [
    ServiceProviderComponent,
    ListServiceProviderComponent,
    FormServiceProviderComponent,
    ModalServiceProviderComponent,
    AutocompleteServiceProviderComponent,
    HistoryServiceProviderComponent,
    TabsServiceProviderComponent,
    MergeServiceProviderComponent
  ],
  providers: [
    ServiceProviderService,
    T2LoadingService
  ],
  exports: [
    ServiceProviderComponent,
    ListServiceProviderComponent,
    FormServiceProviderComponent,
    ModalServiceProviderComponent,
    AutocompleteServiceProviderComponent
  ]
})
export class ServiceProviderModule { }



// WEBPACK FOOTER //
// ./src/app/pages/service-provider/service-provider.module.ts